import { Store } from 'antd/lib/form/interface';
import { IntlShape } from 'react-intl';
import { deleteDataCall, postDataCall, putDataCall } from 'services/api';
import apiPaths from 'services/apiPaths';
import { openToast } from 'src/components/general/Toast';
import { IAddressData, ICustomerAddress } from 'src/shared/models';

export const isDefaultRequired = (
  updatedAddress: Store,
  address: ICustomerAddress,
  key: 'default_billing' | 'default_shipping'
) => {
  if (updatedAddress[key]) return false;

  return address?.[key];
};

export const showSuccessNotification = (type: string, intl: IntlShape) => {
  return openToast(
    intl.formatMessage({ id: `page.account.addresses.${type}-success` }),
    'success'
  );
};

export const showErrorNotification = (type: string, intl: IntlShape) => {
  return openToast(
    intl.formatMessage({ id: `page.account.addresses.${type}-error` }),
    'error',
    4,
    'cross-red',
    'increase_30'
  );
};

export const createAddress = async (newAddress: IAddressData) =>
  await postDataCall({
    dataPath: `${apiPaths.PROFILE.USER_ADDRESS}`,
    data: newAddress,
    callConfig: {},
  });

export const updateAddress = async (address: IAddressData) =>
  await putDataCall({
    dataPath: `${apiPaths.PROFILE.USER_ADDRESS}`,
    data: address,
    callConfig: {},
  });

export const setDefaultAddress = async (id: number) =>
  await putDataCall({
    dataPath: `${apiPaths.PROFILE.USER_ADDRESS}/default/${id}`,
    data: {},
    callConfig: {},
  });

export const deleteAddress = async (id: number) =>
  await deleteDataCall({
    dataPath: `${apiPaths.PROFILE.USER_ADDRESS}`,
    id: id,
    callConfig: {},
  });
